import React from "react";
import HomePageHero from "../components/homepage/HomePageHero";
import WelcomeToHkiMedia from "../components/homepage/WelcomeToHkiMedia";
import MediaNews from "../components/homepage/MediaNews";
import IndustryLeaders from "../components/homepage/IndustryLeaders";
// import OurWork from "../components/homepage/OurWork";
import OurServices from "../components/homepage/OurServices";
import OurClients from "../components/homepage/OurClients";
import Affiliations from "../components/homepage/Partners";
import Partners from "../components/homepage/Affiliations";
import WhatWeDo from "../components/homepage/WhatWeDo";

const HomePage = () => {
  return (
    <div className="home-page-theme">
      <div className="home-stack">
        <HomePageHero />
        <WelcomeToHkiMedia />
      </div>
      <WhatWeDo/>
      {/* <OurWork/> */}
      <OurServices />

      <OurClients/>
      <Affiliations/>
      <Partners/>
      <IndustryLeaders />
      {/* <MeetTheTeam /> */}
      <MediaNews />
    </div>
  );
};

export default HomePage;
